export default __webpack_public_path__ + "static/media/UberScNcGe.5567a741.png";